import styled from "styled-components";

export const Journey = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #e5e5f1;
  box-sizing: border-box;
  font-family: "Nunito Sans", sans-serif;
  overflow-y: auto;

  .journey-content {
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: white;
    margin: 0 10%;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
  }

  .blocks-container {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    padding: 0 10px 0 20px;
    overflow: auto;

    .toggle-banner {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-bottom: 20px;

      .toggle-text {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #f2f2f8;
        border-radius: 20px;
        padding: 6px 16px;
        font-size: 14px;
        color: #3e3e5b;
        cursor: pointer;

        i {
          font-size: 17px;
        }

        strong {
          font-weight: 700;
        }
      }

      .dashed-line {
        flex: 1;
        height: 1px;
        border-top: 1px dashed #d1d5f0;
      }
    }
  }
`;
